import UseOfSoldHeader from "./Header";
import "./index.css";
import CompDirectUseSoldContent from "./CompDirectUseSold";
import IntermediateUseContents from "./IntermediateUseSold";
import IndirectUseContents from "./CompIndirectUseSold";
import { ShowHide } from "../components/ShowHideProduct";
import FlowNumbersBox from "../components/FlowNumbersBox";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
const UseOfSoldComponent = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  return (
    <div className="comp-use-sold-container" id="comp-usc-id">
      <UseOfSoldHeader productId={productId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 16"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <CompDirectUseSoldContent productId={productId} />}
      {show && <IndirectUseContents productId={productId} />}
      {show && <IntermediateUseContents productId={productId} />}
    </div>
  );
};

export default UseOfSoldComponent;
